// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Attendance page (AttendanceComp) — every rule is scoped under .attendance-page. */

.attendance-page {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-4);
}

.attendance-page__loading {
  align-items: center;
  justify-content: center;
  min-height: 40vh;
}

.attendance-page .attendance-main-cards {
  height: 100%;
  border-radius: var(--ds-radius-lg);
  border-color: var(--ds-border-soft);
  box-shadow: var(--ds-shadow-xs);
}

.attendance-page .attendance-page__card-title {
  margin: 0 0 var(--ds-space-3);
  font-weight: 600;
  color: var(--ds-text);
}

.attendance-page .attendance-page__date {
  font-size: 0.8rem;
  font-weight: 400;
}

.attendance-page .attendance-page__label {
  margin-bottom: var(--ds-space-1);
  font-size: 0.8rem;
  font-weight: 500;
  color: var(--ds-text-2);
}

.attendance-page .attendance-page__status {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--ds-space-3);
  margin-bottom: var(--ds-space-4);
  padding: var(--ds-space-3);
  background: var(--ds-surface-muted);
  border: 1px solid var(--ds-border-soft);
  border-radius: var(--ds-radius-md);
}

.attendance-page .attendance-page__hours {
  margin-bottom: var(--ds-space-4);
  text-align: center;
}

/* Actions share a row when the card is wide enough, otherwise stack as full-width targets. */
.attendance-page .attendance-page__actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--ds-space-2);
  margin-bottom: var(--ds-space-4);
}

.attendance-page .attendance-page__actions .ant-btn {
  min-height: 40px;
  height: auto;
  white-space: normal;
}

.attendance-page .attendance-page__actions .attendance-page__stop {
  grid-column: 1 / -1;
}

.attendance-page .attendance-page__mini-stat {
  height: 100%;
  text-align: center;
  border-color: var(--ds-border-soft);
}

.attendance-page .stats-info {
  margin: 0 0 var(--ds-space-2);
  padding: var(--ds-space-2) var(--ds-space-3);
  border: 1px solid var(--ds-border-soft);
  border-radius: var(--ds-radius-md);
  background: var(--ds-surface);
}

.attendance-page .stats-info p {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: var(--ds-space-2);
  margin: 0 0 var(--ds-space-1);
  font-weight: 500;
  color: var(--ds-text);
}

.attendance-page .stats-info .ant-progress {
  margin-bottom: 0;
}

.attendance-page .attendance-page__timeline {
  padding-top: var(--ds-space-2);
}

.attendance-page .attendance-page__time {
  font-size: 0.8rem;
}

.attendance-page .ant-timeline-item-content {
  padding: var(--ds-space-2) var(--ds-space-3);
  background: var(--ds-surface-muted);
  border-radius: var(--ds-radius-sm);
  border-inline-start: 3px solid var(--ds-brand);
}

.attendance-page .attendance-page__history {
  border-radius: var(--ds-radius-lg);
  border-color: var(--ds-border-soft);
}

.attendance-page .ant-tag {
  border-radius: var(--ds-radius-sm);
  font-weight: 500;
}

/* Column search dropdown renders in a portal, so it carries its own class. */
.attendance-page__filter {
  padding: var(--ds-space-2);
}

.attendance-page__filter .ant-input {
  display: block;
  margin-bottom: var(--ds-space-2);
}

/* Three cards side by side: cap the activity list so the row stays even. */
@media (min-width: 1200px) {
  .attendance-page .attendance-page__timeline {
    max-height: 440px;
    overflow-y: auto;
  }
}

/* Clock card: "now" or an entered time, then the project for the next block. */
.attendance-page .attendance-page__when {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--ds-space-2);
  margin-bottom: var(--ds-space-3);
}

.attendance-page .attendance-page__when .attendance-page__time {
  flex: 1 1 120px;
  max-width: 160px;
}

.attendance-page .attendance-page__project {
  width: 100%;
  margin-bottom: var(--ds-space-3);
}

.attendance-page .attendance-page__hours .ant-typography {
  display: block;
}

.attendance-page .attendance-page__inline-tag {
  margin-inline-start: var(--ds-space-1);
}

.attendance-page .attendance-page__tags {
  display: inline-flex;
  flex-wrap: wrap;
  gap: var(--ds-space-1);
}

.attendance-page .attendance-page__month-head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--ds-space-3);
  margin-bottom: var(--ds-space-3);
}

.attendance-page .attendance-page__month-head .attendance-page__card-title {
  margin: 0;
}

.attendance-page .attendance-page__month-tools {
  display: flex;
  flex-wrap: wrap;
  gap: var(--ds-space-2);
}

.attendance-page .attendance-page__month-picker {
  min-width: 170px;
}

.attendance-page .attendance-page__month-totals {
  display: flex;
  flex-wrap: wrap;
  gap: var(--ds-space-2) var(--ds-space-5);
  margin-bottom: var(--ds-space-3);
  padding: var(--ds-space-2) var(--ds-space-3);
  background: var(--ds-surface-muted);
  border-radius: var(--ds-radius-md);
}

.attendance-page .ant-table-row {
  cursor: pointer;
}

/* ── Day editor (drawer renders in a portal, so it has its own root class) ── */
.attendance-editor .attendance-editor__head {
  display: flex;
  align-items: center;
  gap: var(--ds-space-2);
  margin-bottom: var(--ds-space-2);
}

.attendance-editor .attendance-editor__help {
  display: block;
  margin-bottom: var(--ds-space-4);
  font-size: 0.85rem;
}

.attendance-editor .attendance-editor__loading {
  display: flex;
  justify-content: center;
  padding: var(--ds-space-8) 0;
}

.attendance-editor .attendance-editor__templates {
  margin-bottom: var(--ds-space-4);
  padding: var(--ds-space-3);
  background: var(--ds-surface-muted);
  border-radius: var(--ds-radius-md);
}

.attendance-editor .attendance-editor__template-list {
  display: flex;
  flex-wrap: wrap;
  gap: var(--ds-space-2);
  margin-top: var(--ds-space-2);
}

.attendance-editor .attendance-editor__points {
  margin: 0;
  padding: 0;
  list-style: none;
}

/* Each point is a stop on a vertical line; the line's colour is the block it starts. */
.attendance-editor .attendance-editor__point {
  position: relative;
  padding: var(--ds-space-2) 0 var(--ds-space-3);
  padding-inline-start: var(--ds-space-5);
  border-inline-start: 3px solid var(--ds-border-soft);
  margin-inline-start: var(--ds-space-2);
}

.attendance-editor .attendance-editor__point::before {
  content: "";
  position: absolute;
  top: 20px;
  inset-inline-start: -8px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: var(--ds-surface);
  border: 3px solid var(--ds-text-2);
}

.attendance-editor .attendance-editor__point--work { border-inline-start-color: var(--ds-success); }
.attendance-editor .attendance-editor__point--work::before { border-color: var(--ds-success); }
.attendance-editor .attendance-editor__point--travel { border-inline-start-color: var(--ds-brand); }
.attendance-editor .attendance-editor__point--travel::before { border-color: var(--ds-brand); }
.attendance-editor .attendance-editor__point--break { border-inline-start-color: var(--ds-warning); }
.attendance-editor .attendance-editor__point--break::before { border-color: var(--ds-warning); }
.attendance-editor .attendance-editor__point--end { border-inline-start-style: dashed; }
.attendance-editor .attendance-editor__point--error::before { border-color: var(--ds-danger); }

.attendance-editor .attendance-editor__row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--ds-space-2);
}

.attendance-editor .attendance-editor__time {
  flex: 0 0 auto;
  width: auto;
  min-width: 108px;
  font-variant-numeric: tabular-nums;
}

.attendance-editor .attendance-editor__select-type {
  flex: 1 1 140px;
  min-width: 0;
}

.attendance-editor .attendance-editor__row-actions {
  display: flex;
  margin-inline-start: auto;
}

.attendance-editor .attendance-editor__row--details {
  margin-top: var(--ds-space-2);
}

.attendance-editor .attendance-editor__project {
  flex: 1 1 200px;
  min-width: 0;
}

.attendance-editor .attendance-editor__note {
  margin-top: var(--ds-space-2);
}

.attendance-editor .attendance-editor__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--ds-space-1) var(--ds-space-2);
  margin-top: var(--ds-space-1);
  font-size: 0.85rem;
}

.attendance-editor .attendance-editor__meta:empty {
  display: none;
}

.attendance-editor .attendance-editor__type {
  display: inline-flex;
  align-items: center;
  gap: var(--ds-space-2);
}

.attendance-editor .attendance-editor__dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--ds-text-2);
}

.attendance-editor .attendance-editor__dot--work { background: var(--ds-success); }
.attendance-editor .attendance-editor__dot--travel { background: var(--ds-brand); }
.attendance-editor .attendance-editor__dot--break { background: var(--ds-warning); }

.attendance-editor .attendance-editor__add {
  display: flex;
  gap: var(--ds-space-2);
  margin: var(--ds-space-2) 0 var(--ds-space-3);
}

.attendance-editor .attendance-editor__running {
  margin-bottom: var(--ds-space-3);
}

.attendance-editor .attendance-editor__extras {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--ds-space-3);
  margin-bottom: var(--ds-space-4);
}

@media (min-width: 576px) {
  .attendance-editor .attendance-editor__extras {
    grid-template-columns: 1fr 2fr;
  }
}

.attendance-editor .attendance-editor__field {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-1);
}

.attendance-editor .attendance-editor__summary {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));
  gap: var(--ds-space-2);
  margin-bottom: var(--ds-space-3);
  padding: var(--ds-space-3);
  background: var(--ds-surface-muted);
  border-radius: var(--ds-radius-md);
}

.attendance-editor .attendance-editor__summary-item {
  display: flex;
  flex-direction: column;
  font-variant-numeric: tabular-nums;
}

.attendance-editor .attendance-editor__alert {
  margin-bottom: var(--ds-space-3);
}

.attendance-editor .attendance-editor__list {
  margin: 0;
  padding-inline-start: var(--ds-space-4);
}

.attendance-editor .attendance-editor__footer {
  display: flex;
  justify-content: space-between;
  gap: var(--ds-space-2);
}

/* Used by the employee profile header avatar (Profile.jsx). */
.employee-profile-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: bold;
  background: var(--ds-brand);
  color: var(--ds-surface);
}

/* Team export dialog (portal, own root class) */
.attendance-team-export .attendance-team-export__format {
  margin-bottom: var(--ds-space-3);
}

.attendance-team-export .attendance-team-export__bulk {
  margin: var(--ds-space-2) 0;
}

.attendance-team-export .attendance-team-export__loading {
  display: flex;
  justify-content: center;
  padding: var(--ds-space-6) 0;
}

.attendance-team-export .attendance-team-export__list {
  max-height: min(50vh, 420px);
  margin: 0;
  padding: 0;
  overflow-y: auto;
  list-style: none;
  border: 1px solid var(--ds-border-soft);
  border-radius: var(--ds-radius-md);
}

.attendance-team-export .attendance-team-export__list li {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--ds-space-1) var(--ds-space-2);
  min-height: 44px;
  padding: var(--ds-space-2) var(--ds-space-3);
  border-bottom: 1px solid var(--ds-border-soft);
}

.attendance-team-export .attendance-team-export__list li:last-child {
  border-bottom: none;
}

.attendance-team-export .attendance-team-export__name {
  font-weight: 500;
  overflow-wrap: anywhere;
}

.attendance-team-export .attendance-team-export__tags {
  display: inline-flex;
  flex-wrap: wrap;
  gap: var(--ds-space-1);
}

.attendance-page .attendance-page__holiday {
  margin-inline-start: var(--ds-space-1);
}
`, "",{"version":3,"sources":["webpack://./src/commons/Employees/Attendance/AttendanceCSS.css"],"names":[],"mappings":"AAAA,oFAAoF;;AAEpF;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kCAAkC;EAClC,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,gCAAgC;EAChC,0BAA0B;EAC1B,mCAAmC;EACnC,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA,6FAA6F;AAC7F;EACE,aAAa;EACb,gDAAgD;EAChD,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,6BAA6B;EAC7B,4CAA4C;EAC5C,uCAAuC;EACvC,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,sBAAsB;EACtB,6BAA6B;EAC7B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,4CAA4C;EAC5C,mCAAmC;EACnC,kCAAkC;EAClC,8CAA8C;AAChD;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA,6EAA6E;AAC7E;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA,2EAA2E;AAC3E;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,wCAAwC;EACxC,gCAAgC;EAChC,4CAA4C;EAC5C,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,eAAe;AACjB;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA,uFAAuF;AACvF;EACE,kBAAkB;EAClB,8CAA8C;EAC9C,uCAAuC;EACvC,oDAAoD;EACpD,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA,qDAAqD,4CAA4C,EAAE;AACnG,6DAA6D,+BAA+B,EAAE;AAC9F,uDAAuD,0CAA0C,EAAE;AACnG,+DAA+D,6BAA6B,EAAE;AAC9F,sDAAsD,4CAA4C,EAAE;AACpG,8DAA8D,+BAA+B,EAAE;AAC/F,oDAAoD,iCAAiC,EAAE;AACvF,8DAA8D,8BAA8B,EAAE;;AAE9F;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,wCAAwC;EACxC,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,mDAAmD,6BAA6B,EAAE;AAClF,qDAAqD,2BAA2B,EAAE;AAClF,oDAAoD,6BAA6B,EAAE;;AAEnF;EACE,aAAa;EACb,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,sBAAsB;EACtB,gCAAgC;EAChC,0BAA0B;EAC1B,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA,8DAA8D;AAC9D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA,gDAAgD;AAChD;EACE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,wCAAwC;EACxC,gBAAgB;EAChB,4CAA4C;EAC5C,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;AACxC","sourcesContent":["/* Attendance page (AttendanceComp) — every rule is scoped under .attendance-page. */\n\n.attendance-page {\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-4);\n}\n\n.attendance-page__loading {\n  align-items: center;\n  justify-content: center;\n  min-height: 40vh;\n}\n\n.attendance-page .attendance-main-cards {\n  height: 100%;\n  border-radius: var(--ds-radius-lg);\n  border-color: var(--ds-border-soft);\n  box-shadow: var(--ds-shadow-xs);\n}\n\n.attendance-page .attendance-page__card-title {\n  margin: 0 0 var(--ds-space-3);\n  font-weight: 600;\n  color: var(--ds-text);\n}\n\n.attendance-page .attendance-page__date {\n  font-size: 0.8rem;\n  font-weight: 400;\n}\n\n.attendance-page .attendance-page__label {\n  margin-bottom: var(--ds-space-1);\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: var(--ds-text-2);\n}\n\n.attendance-page .attendance-page__status {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--ds-space-3);\n  margin-bottom: var(--ds-space-4);\n  padding: var(--ds-space-3);\n  background: var(--ds-surface-muted);\n  border: 1px solid var(--ds-border-soft);\n  border-radius: var(--ds-radius-md);\n}\n\n.attendance-page .attendance-page__hours {\n  margin-bottom: var(--ds-space-4);\n  text-align: center;\n}\n\n/* Actions share a row when the card is wide enough, otherwise stack as full-width targets. */\n.attendance-page .attendance-page__actions {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: var(--ds-space-2);\n  margin-bottom: var(--ds-space-4);\n}\n\n.attendance-page .attendance-page__actions .ant-btn {\n  min-height: 40px;\n  height: auto;\n  white-space: normal;\n}\n\n.attendance-page .attendance-page__actions .attendance-page__stop {\n  grid-column: 1 / -1;\n}\n\n.attendance-page .attendance-page__mini-stat {\n  height: 100%;\n  text-align: center;\n  border-color: var(--ds-border-soft);\n}\n\n.attendance-page .stats-info {\n  margin: 0 0 var(--ds-space-2);\n  padding: var(--ds-space-2) var(--ds-space-3);\n  border: 1px solid var(--ds-border-soft);\n  border-radius: var(--ds-radius-md);\n  background: var(--ds-surface);\n}\n\n.attendance-page .stats-info p {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: var(--ds-space-2);\n  margin: 0 0 var(--ds-space-1);\n  font-weight: 500;\n  color: var(--ds-text);\n}\n\n.attendance-page .stats-info .ant-progress {\n  margin-bottom: 0;\n}\n\n.attendance-page .attendance-page__timeline {\n  padding-top: var(--ds-space-2);\n}\n\n.attendance-page .attendance-page__time {\n  font-size: 0.8rem;\n}\n\n.attendance-page .ant-timeline-item-content {\n  padding: var(--ds-space-2) var(--ds-space-3);\n  background: var(--ds-surface-muted);\n  border-radius: var(--ds-radius-sm);\n  border-inline-start: 3px solid var(--ds-brand);\n}\n\n.attendance-page .attendance-page__history {\n  border-radius: var(--ds-radius-lg);\n  border-color: var(--ds-border-soft);\n}\n\n.attendance-page .ant-tag {\n  border-radius: var(--ds-radius-sm);\n  font-weight: 500;\n}\n\n/* Column search dropdown renders in a portal, so it carries its own class. */\n.attendance-page__filter {\n  padding: var(--ds-space-2);\n}\n\n.attendance-page__filter .ant-input {\n  display: block;\n  margin-bottom: var(--ds-space-2);\n}\n\n/* Three cards side by side: cap the activity list so the row stays even. */\n@media (min-width: 1200px) {\n  .attendance-page .attendance-page__timeline {\n    max-height: 440px;\n    overflow-y: auto;\n  }\n}\n\n/* Clock card: \"now\" or an entered time, then the project for the next block. */\n.attendance-page .attendance-page__when {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: var(--ds-space-2);\n  margin-bottom: var(--ds-space-3);\n}\n\n.attendance-page .attendance-page__when .attendance-page__time {\n  flex: 1 1 120px;\n  max-width: 160px;\n}\n\n.attendance-page .attendance-page__project {\n  width: 100%;\n  margin-bottom: var(--ds-space-3);\n}\n\n.attendance-page .attendance-page__hours .ant-typography {\n  display: block;\n}\n\n.attendance-page .attendance-page__inline-tag {\n  margin-inline-start: var(--ds-space-1);\n}\n\n.attendance-page .attendance-page__tags {\n  display: inline-flex;\n  flex-wrap: wrap;\n  gap: var(--ds-space-1);\n}\n\n.attendance-page .attendance-page__month-head {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--ds-space-3);\n  margin-bottom: var(--ds-space-3);\n}\n\n.attendance-page .attendance-page__month-head .attendance-page__card-title {\n  margin: 0;\n}\n\n.attendance-page .attendance-page__month-tools {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--ds-space-2);\n}\n\n.attendance-page .attendance-page__month-picker {\n  min-width: 170px;\n}\n\n.attendance-page .attendance-page__month-totals {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--ds-space-2) var(--ds-space-5);\n  margin-bottom: var(--ds-space-3);\n  padding: var(--ds-space-2) var(--ds-space-3);\n  background: var(--ds-surface-muted);\n  border-radius: var(--ds-radius-md);\n}\n\n.attendance-page .ant-table-row {\n  cursor: pointer;\n}\n\n/* ── Day editor (drawer renders in a portal, so it has its own root class) ── */\n.attendance-editor .attendance-editor__head {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-2);\n  margin-bottom: var(--ds-space-2);\n}\n\n.attendance-editor .attendance-editor__help {\n  display: block;\n  margin-bottom: var(--ds-space-4);\n  font-size: 0.85rem;\n}\n\n.attendance-editor .attendance-editor__loading {\n  display: flex;\n  justify-content: center;\n  padding: var(--ds-space-8) 0;\n}\n\n.attendance-editor .attendance-editor__templates {\n  margin-bottom: var(--ds-space-4);\n  padding: var(--ds-space-3);\n  background: var(--ds-surface-muted);\n  border-radius: var(--ds-radius-md);\n}\n\n.attendance-editor .attendance-editor__template-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--ds-space-2);\n  margin-top: var(--ds-space-2);\n}\n\n.attendance-editor .attendance-editor__points {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n/* Each point is a stop on a vertical line; the line's colour is the block it starts. */\n.attendance-editor .attendance-editor__point {\n  position: relative;\n  padding: var(--ds-space-2) 0 var(--ds-space-3);\n  padding-inline-start: var(--ds-space-5);\n  border-inline-start: 3px solid var(--ds-border-soft);\n  margin-inline-start: var(--ds-space-2);\n}\n\n.attendance-editor .attendance-editor__point::before {\n  content: \"\";\n  position: absolute;\n  top: 20px;\n  inset-inline-start: -8px;\n  width: 13px;\n  height: 13px;\n  border-radius: 50%;\n  background: var(--ds-surface);\n  border: 3px solid var(--ds-text-2);\n}\n\n.attendance-editor .attendance-editor__point--work { border-inline-start-color: var(--ds-success); }\n.attendance-editor .attendance-editor__point--work::before { border-color: var(--ds-success); }\n.attendance-editor .attendance-editor__point--travel { border-inline-start-color: var(--ds-brand); }\n.attendance-editor .attendance-editor__point--travel::before { border-color: var(--ds-brand); }\n.attendance-editor .attendance-editor__point--break { border-inline-start-color: var(--ds-warning); }\n.attendance-editor .attendance-editor__point--break::before { border-color: var(--ds-warning); }\n.attendance-editor .attendance-editor__point--end { border-inline-start-style: dashed; }\n.attendance-editor .attendance-editor__point--error::before { border-color: var(--ds-danger); }\n\n.attendance-editor .attendance-editor__row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: var(--ds-space-2);\n}\n\n.attendance-editor .attendance-editor__time {\n  flex: 0 0 auto;\n  width: auto;\n  min-width: 108px;\n  font-variant-numeric: tabular-nums;\n}\n\n.attendance-editor .attendance-editor__select-type {\n  flex: 1 1 140px;\n  min-width: 0;\n}\n\n.attendance-editor .attendance-editor__row-actions {\n  display: flex;\n  margin-inline-start: auto;\n}\n\n.attendance-editor .attendance-editor__row--details {\n  margin-top: var(--ds-space-2);\n}\n\n.attendance-editor .attendance-editor__project {\n  flex: 1 1 200px;\n  min-width: 0;\n}\n\n.attendance-editor .attendance-editor__note {\n  margin-top: var(--ds-space-2);\n}\n\n.attendance-editor .attendance-editor__meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: var(--ds-space-1) var(--ds-space-2);\n  margin-top: var(--ds-space-1);\n  font-size: 0.85rem;\n}\n\n.attendance-editor .attendance-editor__meta:empty {\n  display: none;\n}\n\n.attendance-editor .attendance-editor__type {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--ds-space-2);\n}\n\n.attendance-editor .attendance-editor__dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: var(--ds-text-2);\n}\n\n.attendance-editor .attendance-editor__dot--work { background: var(--ds-success); }\n.attendance-editor .attendance-editor__dot--travel { background: var(--ds-brand); }\n.attendance-editor .attendance-editor__dot--break { background: var(--ds-warning); }\n\n.attendance-editor .attendance-editor__add {\n  display: flex;\n  gap: var(--ds-space-2);\n  margin: var(--ds-space-2) 0 var(--ds-space-3);\n}\n\n.attendance-editor .attendance-editor__running {\n  margin-bottom: var(--ds-space-3);\n}\n\n.attendance-editor .attendance-editor__extras {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: var(--ds-space-3);\n  margin-bottom: var(--ds-space-4);\n}\n\n@media (min-width: 576px) {\n  .attendance-editor .attendance-editor__extras {\n    grid-template-columns: 1fr 2fr;\n  }\n}\n\n.attendance-editor .attendance-editor__field {\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-1);\n}\n\n.attendance-editor .attendance-editor__summary {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));\n  gap: var(--ds-space-2);\n  margin-bottom: var(--ds-space-3);\n  padding: var(--ds-space-3);\n  background: var(--ds-surface-muted);\n  border-radius: var(--ds-radius-md);\n}\n\n.attendance-editor .attendance-editor__summary-item {\n  display: flex;\n  flex-direction: column;\n  font-variant-numeric: tabular-nums;\n}\n\n.attendance-editor .attendance-editor__alert {\n  margin-bottom: var(--ds-space-3);\n}\n\n.attendance-editor .attendance-editor__list {\n  margin: 0;\n  padding-inline-start: var(--ds-space-4);\n}\n\n.attendance-editor .attendance-editor__footer {\n  display: flex;\n  justify-content: space-between;\n  gap: var(--ds-space-2);\n}\n\n/* Used by the employee profile header avatar (Profile.jsx). */\n.employee-profile-avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  font-weight: bold;\n  background: var(--ds-brand);\n  color: var(--ds-surface);\n}\n\n/* Team export dialog (portal, own root class) */\n.attendance-team-export .attendance-team-export__format {\n  margin-bottom: var(--ds-space-3);\n}\n\n.attendance-team-export .attendance-team-export__bulk {\n  margin: var(--ds-space-2) 0;\n}\n\n.attendance-team-export .attendance-team-export__loading {\n  display: flex;\n  justify-content: center;\n  padding: var(--ds-space-6) 0;\n}\n\n.attendance-team-export .attendance-team-export__list {\n  max-height: min(50vh, 420px);\n  margin: 0;\n  padding: 0;\n  overflow-y: auto;\n  list-style: none;\n  border: 1px solid var(--ds-border-soft);\n  border-radius: var(--ds-radius-md);\n}\n\n.attendance-team-export .attendance-team-export__list li {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--ds-space-1) var(--ds-space-2);\n  min-height: 44px;\n  padding: var(--ds-space-2) var(--ds-space-3);\n  border-bottom: 1px solid var(--ds-border-soft);\n}\n\n.attendance-team-export .attendance-team-export__list li:last-child {\n  border-bottom: none;\n}\n\n.attendance-team-export .attendance-team-export__name {\n  font-weight: 500;\n  overflow-wrap: anywhere;\n}\n\n.attendance-team-export .attendance-team-export__tags {\n  display: inline-flex;\n  flex-wrap: wrap;\n  gap: var(--ds-space-1);\n}\n\n.attendance-page .attendance-page__holiday {\n  margin-inline-start: var(--ds-space-1);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
